
$('#videoModal').on('shown.bs.modal', function () {
  if (ga) ga('send', 'event', 'Product', 'open', 'The Bump Slider');
});
$('#sizeChart').on('shown.bs.modal', function () {
  if (ga) ga('send', 'event', 'Product', 'open', 'The Size Chart');
});

//	-------------------------
//	Listen for a Swatch Click
//	-------------------------
$(function () {
  $(".product_gallery .product_images .slick-slider").each(function (i, slider) {
    const change = function (e, slick) {
      const isMobile = $(window).width() < 768;
      const slide = slick.$slides[slick.currentSlide];
      if (isMobile) {
        $(slide).trigger('zoom.destroy')
        return;
      }
      const img_url = $(slide).data("src");
      $(slide).trigger('zoom.destroy').zoom({ url: img_url })
    };
    const color = $(slider).data("color");
    const thumb = $(color ? '[data-color="' + color + '"]' : '.slick-slider.no-color', ".product_gallery .img-thumbs");

    const main = $(slider).slick({
      arrows: true,
      infinite: true,
      accessibility: false
    })
      .on("afterChange", change)
      .on("init", change)
      .on("beforeChange", function (e, slick, currentSlide, nextSlide) {
        if (!color || (color && thumb.find(".slick-slide").length > 4))
          thumb.slick("slickGoTo", nextSlide)
        else {
          thumb.find(".slick-current").removeClass("slick-current")
          thumb.find(".slick-slide[data-slick-index='" + nextSlide + "']").addClass("slick-current")
        }
      })
    thumb.slick({
      slidesToShow: 4,
      arrows: true,
      vertical: true,
      infinite: color != null,
      verticalSwiping: true,
      accessibility: false
    }).on("beforeChange", function (e, slick, currentSlide, nextSlide) {
      $(slider).slick("slickGoTo", nextSlide);
    })

    thumb.find(".slick-slide").on("click", function (e) {
      main.slick("slickGoTo", $(this).data("slick-index"))
    })

  })
  window.NPO.events.swatchClick.after.push(function (clicked_swatch) {
    if (clicked_swatch.parentElement.getAttribute('data-option_label') != 'color') {
      return;
    }

    $(".product_gallery .slick-slider.active").removeClass("active")

    let imgSlider, thumbSlider;

    //	Hide/Show Desktop Image Wrapper for clicked color
    var color_handle = clicked_swatch.getAttribute('data-option_value').trim().toLowerCase().replace(/[^a-z0-9]+/gi, '-');
    if (!$(clicked_swatch).hasClass("selected"))
      color_handle = "";

    if (color_handle) {
      imgSlider = $(`[data-color="${color_handle}"]`, ".product_gallery .product_images")
      thumbSlider = $(`[data-color="${color_handle}"]`, ".product_gallery .img-thumbs")
    }
    if (!imgSlider || !imgSlider.length) {
      imgSlider = $(`.slick-slider.no-color`, ".product_gallery .product_images")
      thumbSlider = $(`.slick-slider.no-color`, ".product_gallery .img-thumbs")
    }
    imgSlider.addClass("active").slick("refresh")
    thumbSlider.addClass("active").slick("refresh")
  });

  //	Put Clicked Swatch Color in URL
  window.NPO.events.swatchClick.after.push(function (clicked_swatch) {
    //	Breakpoint
    if (clicked_swatch.parentElement.getAttribute('data-option_label') != 'color') {
      return;
    } //if
    var color_handle = clicked_swatch.getAttribute('data-option_value').trim().toLowerCase().replace(/[^a-z0-9]+/gi, '-');
    if (window.location.search.indexOf('color') != -1) {
      var new_url = window.location.href.replace(/color=([\w-]+)/i, 'color=' + color_handle);
    } else {
      var new_url = window.location.href + '?color=' + color_handle;
    } //ifelse
    //	console.log( new_url );	//	Debugging Only
    window.history.replaceState({}, document.title, new_url);
  });
})
